import React from 'react'
import { WIDE_LAYOUT_KEY } from 'shared/constants/storage'
import { useIsMobile } from 'shared/hooks/useIsMobile'

// Шире этого окна раскладка широкая, пока пользователь не выбрал сам
const WIDE_BY_DEFAULT_AFTER = 1920
// Уже 1280px (ступень сайта) широкая раскладка выигрывает меньше 150px — кнопку
// не показываем, и раскладка всегда узкая, чтобы не застрять в режиме без кнопки
const TOGGLE_HIDDEN_MAX_WIDTH = 1279

const readSavedChoice = (): boolean | null => {
  try {
    const value = localStorage.getItem(WIDE_LAYOUT_KEY)
    return value === null ? null : value === '1'
  } catch {
    return null
  }
}

// Выбор читают и шапка, и меню кабинета, поэтому он живёт вне компонентов
let savedChoice = readSavedChoice()
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSavedChoice = () => savedChoice

// Широкая раскладка — рабочая область шириной с сайт, узкая — 1074px
export const useWideLayout = () => {
  const choice = React.useSyncExternalStore(subscribe, getSavedChoice)
  const isWideByDefault = !useIsMobile(WIDE_BY_DEFAULT_AFTER)
  const canToggle = !useIsMobile(TOGGLE_HIDDEN_MAX_WIDTH)
  const isWide = canToggle && (choice ?? isWideByDefault)

  const toggle = () => {
    savedChoice = !isWide
    try {
      localStorage.setItem(WIDE_LAYOUT_KEY, savedChoice ? '1' : '0')
    } catch {
      // localStorage недоступен — выбор продержится до перезагрузки
    }
    listeners.forEach((listener) => listener())
  }

  return { isWide, canToggle, toggle }
}
